import * as React from "react";
import {useEffect, useContext} from "react";
import {Actuality} from "../queries/Actuality";
import {ActualityContext, ActualitiesContext} from "../context/actualityContext";
import {useParams} from "react-router-dom";

export const useActuality = (eventId) => {
    const {state, dispatch} = useContext(ActualityContext);
    useEffect(()=> {
        !state.hasOwnProperty('id') &&
        Actuality.getActualities(eventId).then((response) => dispatch({type: "initActuality",payload:response}))
    },[])

    return {actualityDetail:state}
}

export const useActualities = (actualities) => {
    const {state, dispatch} = useContext(ActualitiesContext);
    const {id} = useParams();
    useEffect(()=> {
        actualities !== undefined && dispatch({type: "initActualities",payload:actualities})
    },[]);

    const updateActualities = () => {
        Actuality.getActualities(id).then((response) => dispatch({type: "initActualities",payload:response}))
    }

    return {actualities:state, updateActualities}
}
